const Config = {
  API_KEY: 'G6cvyvKXEdD3cC9i4xed8wHK3WpeLiI3sH7Fg3i2',
  VAPID_KEY: 'BAUqtXuiFMMyh-hkTDapvr02G-LQYDIy7Zr1pPGe3LVdTWJ1c4lrAPzrbj-o3ksCcLcHgxzkmR5XteKomsJEXFw'
};

export default Config;
